import React from 'react';
import {  Container, Row, Col, Accordion} from 'react-bootstrap';
import '../Assets/Css/faqs.css';
import productbanner from '../Assets/Images/Faqs.jpg';
import { BsQuestionSquare } from "react-icons/bs";
import { Helmet } from "react-helmet";

export default function FAQs() {

    const faqData = [
        {
          question: '1. What types of mechanical parts do you manufacture and supply?',
          answer:
            'We manufacture and trade a wide range of mechanical components, including shafts, bushings, couplings, fasteners, stainless steel parts, seals, and custom-engineered components for industrial applications.',
        },
        {
          question: '2. Do you offer parts suitable for the pharmaceutical, dairy, and food industries?',
          answer:
            'Yes. We specialize in supplying food-grade and pharma-compliant components made from high-quality stainless steel and other certified materials suitable for hygienic environments.',
        },
        {
          question: '3. Can you manufacture custom mechanical parts based on our specifications?',
          answer:
            'Absolutely. We offer custom manufacturing services and can produce components based on your technical drawings, samples, or design inputs.',
        },
        {
          question: '4. What materials do you commonly work with?',
          answer:
            'We work with a wide range of materials including SS 304, SS 316, MS, brass, aluminum, and various engineering plastics depending on your application needs.',
        },
        {
          question: '5. Do you provide product documentation or certifications?',
          answer:
            'Yes. We can provide material test certificates (MTCs), compliance documents (FDA, RoHS), and quality inspection reports upon request.',
        },
        {
          question: '6. What is your typical lead time for orders?',
          answer:
            'Lead time varies depending on the product and quantity. Standard items are usually shipped within a few days, while custom parts may take 1–3 weeks depending on complexity.',
        },
        {
          question: '7. Do you deliver across India or internationally?',
          answer:
            'Yes. We serve clients across India and can ship internationally depending on the order size and compliance requirements.',
        },
        {
          question: '8. How can I request a quote or place an order?',
          answer:
            'You can request a quote by contacting us via our website, email, or phone. Once we receive your requirements, our team will respond promptly with pricing and lead time.',
        },
      ];

  return (
    <>
      <div className="mainnav">
      <Helmet>
        <title>Frequently Asked Questions | AIM Industrial Products</title>

        <meta
          name="description"
          content="Find quick answers to the most common questions about AIM Industrial Products – including materials, industries served, custom manufacturing, delivery, and certifications."
        />
        <meta
          name="keywords"
          content="FAQ, AIM Industrial Products, mechanical components FAQ, pharma parts, dairy equipment, custom mechanical parts, hygienic fittings, industrial supplies, product documentation"
        />
        <meta name="author" content="AIM Industrial Products" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="FAQs | AIM Industrial Products"
        />
        <meta
          property="og:description"
          content="Answers to frequently asked questions about our hygienic components, materials, certifications, custom part capabilities, and delivery options."
        />
        <meta
          property="og:image"
          content="https://yourdomain.com/assets/faq-banner.jpg" // Replace with your actual FAQ banner image
        />
        <meta property="og:url" content="https://aimindproducts.com/faq" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="FAQs – AIM Industrial Products"
        />
        <meta
          name="twitter:description"
          content="Learn more about our services, product capabilities, custom options, and industry compliance in our FAQ section."
        />
        <meta
          name="twitter:image"
          content="https://yourdomain.com/assets/faq-banner.jpg" // Replace with your actual FAQ image
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://aimindproducts.com/faq" />
      </Helmet>
        {/* Banner Section */}
        <div className="about-banner position-relative text-white mb-4">
          <img
            src={productbanner}
            alt="About Banner"
            className="aboutbanner-image animate-banner-zoom"
          />
          <div className="maindesc position-absolute top-50 start-50 translate-middle text-center px-3">
            <h2 className="fw-bold glitch" data-text="Frequently Asked Questions">
              Frequently Asked Questions
            </h2>
            <p className="lead">
            Find quick answers to common questions about our products and services.         
             </p>
         
          </div>
        </div>
      </div>

      {/* FAQs Section */}
      <Container className="my-4">
      <h2 className="Mainhead"><BsQuestionSquare />  Frequently Asked Questions</h2>
     
      <Row className="justify-content-center mt-5">
        <Col lg={10}>
          <Accordion defaultActiveKey="0" className="faq-accordion ">
            {faqData.map((item, index) => (
              <Accordion.Item className='mb-3' eventKey={index.toString()} key={index}>
                <Accordion.Header>{item.question}</Accordion.Header>
                <Accordion.Body>{item.answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Col>
      </Row>
   
      </Container>
    </>
  );
}
